// StudentBookList.jsx
import React, { useState, useEffect } from "react";
import api from "../../../api/api";
import ParentPanel from "../panel/ParentPanel";
import "../styles/StudentBookList.css";

const StudentBookList = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showBooks, setShowBooks] = useState(false);
  const [bookList, setBookList] = useState(null);

  useEffect(() => {
    const fetchBookList = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

    const res = await api.get("/api/student-booklist", {
      headers: { Authorization: `Bearer ${token}` }
    });


        setBookList(res.data);
      } catch (err) {
        console.error("❌ Error fetching book list:", err);
      }
    };

    fetchBookList();
  }, []);

  if (!bookList) {
    return (
      <>
        <ParentPanel onToggle={setIsSidebarCollapsed} />
        <div className={`sbs-main-container ${isSidebarCollapsed ? "collapsed" : ""}`}>
          <h2 className="sbs-page-title">Book List</h2>
          <p style={{ color: "#777" }}>Loading book list...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div className={`sbs-main-container ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h2 className="sbs-page-title">Book List</h2>

        {/* Single Class Card */}
        <div className="sbs-class-card" onClick={() => setShowBooks(true)}>
          <h3>Class {bookList.class} Book List</h3>
          <p>Click to view full book list</p>
        </div>

        {/* Book List Modal */}
        {showBooks && (
          <div className="sbs-detail-overlay">
            <div className="sbs-detail-box">
              <button className="sbs-close-btn" onClick={() => setShowBooks(false)}>✖</button>
              <h3 className="sbs-detail-header">Class {bookList.class} Book List</h3>
              <div className="sbs-detail-table-container">
                <table className="sbs-detail-table">
                  <thead>
                    <tr>
                      <th>Book Name</th>
                      <th>Writer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookList.books.map((b, idx) => (
                      <tr key={idx}>
                        <td>{b.name}</td>
                        <td>{b.writer}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StudentBookList;
